import { useMemo } from "react";
import styles from "./Confetti.module.css";

const COLORS = ["#FFB443", "#0E7C86", "#FF6B6B", "#5FBF62", "#8AD3E8"];

/** Confeti de celebración (cierre de evaluación). Determinístico por índice para
 *  no depender de Math.random en render/SSR/tests. */
export function Confetti({ count = 36 }: { count?: number }) {
  const pieces = useMemo(
    () =>
      Array.from({ length: count }, (_, i) => ({
        left: ((i * 37) % 100) + "%",
        bg: COLORS[i % COLORS.length]!,
        dur: 2.4 + ((i * 13) % 24) / 10 + "s",
        delay: ((i * 7) % 14) / 10 + "s",
      })),
    [count],
  );
  return (
    <div className={styles.wrap} aria-hidden="true">
      {pieces.map((p, i) => (
        <i
          key={i}
          style={{ left: p.left, background: p.bg, animationDuration: p.dur, animationDelay: p.delay }}
        />
      ))}
    </div>
  );
}
